import React from "react";
import { useEmailAccount } from "../../../../providers/EmailAccountProvider/useEmailAccount";
import { GmailAccountHeaderCard } from "./components/GmailAccountHeaderCard";
import { ResponseModeSection } from "./components/ResponseModeSection";
import { HowItWorksSection } from "./components/HowItWorksSection";

export const EmailAccountScreen: React.FC = () => {
  const { emailAccount } = useEmailAccount();

  if (!emailAccount) {
    return null;
  }

  return (
    <div className="flex h-full flex-col gap-6 overflow-y-auto bg-grey-100 p-8">
      <GmailAccountHeaderCard />
      <ResponseModeSection />
      <HowItWorksSection />
    </div>
  );
};
